var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStraightLine = function SvgStraightLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 265,
    height: 265,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#00EA90",
    strokeWidth: 6,
    d: "M377-39.57c0 102.754-.038 212.094-.038 230.619 0 18.525-6.565 42.733-30.997 59.2-23.678 15.959-60.748 16.008-79.237-1.976C248.24 230.288 38.261 24.523 24.357 11.513 10.453-1.494-3.999-30.146 9.207-67.033c13.207-36.886 42.92-43.015 60.089-43.673 17.168-.659 215.261 0 236.391 0 21.129 0 38.298 3.293 50.843 15.15C372.465-80.5 377-65.918 377-39.57Z"
  })));
};
export default SvgStraightLine;